<ui-button (clicked)="logout()">Agent abmelden</ui-button>

<ui-agent-search></ui-agent-search>
